import { CLOUDINARY_BASE_URL } from '../../config/cloudinary';
import { CATEGORY_LABELS, PRICE_UNITS, TAG_LABELS } from './constants';

export const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

const formatYen = (amount) => `¥${amount.toLocaleString('en-US')}`;

const formatPrice = (lang, price) => {
  if (!price) return undefined;

  const amount = `${formatYen(price.amount)}${price.from ? '〜' : ''} JPY`;

  if (!price.unit) {
    return amount;
  }

  return `${amount} / ${PRICE_UNITS[lang][price.unit]}`;
};

export const buildTour = (lang, tour) => {
  const text = tour.texts[lang];

  return {
    href: tour.href,
    isComingSoon: Boolean(tour.isComingSoon),
    categoryKey: tour.categoryKey,
    category: CATEGORY_LABELS[lang][tour.categoryKey],

    ...(tour.tagKey && {
      tag: TAG_LABELS[lang][tour.tagKey],
    }),

    ...(tour.discountRate && {
      discountRate: tour.discountRate,
    }),

    images: tour.cardImage
      ? [tour.cardImage, ...tour.images.filter((image) => image !== tour.cardImage)]
      : tour.images,
    title: text.title,
    tags: tour.tags,
    time: tour.time,
    startTimes: text.startTimes,
    people: text.people,

    ...(tour.originalPrice && {
      originalPrice: formatPrice(lang, tour.originalPrice),
    }),

    salePrice: formatPrice(lang, tour.salePrice),

    ...(text.notes && {
      notes: text.notes,
    }),

  };
};

export const buildTourDetail = (lang, tour) => {
  const text = tour.detailTexts?.[lang];

  if (!tour.detail || !text) return null;

  return {
    ...tour.detail,

    slug: tour.slug,
    id: tour.id,
    href: tour.href,

    title: text.title,
    pathTitle: text.pathTitle,

    heroTitle: text.heroTitle,
    heroDescription: text.heroDescription,

    description: text.description,
    featureIntro: text.featureIntro,
    highlights: text.highlights,

    detailItems: text.detailItems,
    included: text.included,
    notIncluded: text.notIncluded,

    price: text.price,

    scheduleItems: text.scheduleItems,
    faqs: text.faqs,
    noteColumns: text.noteColumns || tour.detail.noteColumns,

    time: text.time,
    startTimes: text.startTimes,
    people: text.people,

    heroPrice: text.heroPrice,
    heroPriceNote: text.heroPriceNote,

    guideInstagram: tour.detail.guideInstagram,
    guideInstagramTitle: text.guideInstagramTitle,
    guideInstagramText: text.guideInstagramText,
    guideInstagramCta: text.guideInstagramCta,

    images: tour.detail.images || tour.images,
  };
};
